import { LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import './SubmitButton.css';

const SubmitButton = ({
  children,
  loading = false,
  htmlType = 'button',
  onClick,
  disabled,
  className = '',
  style,
  size = 'middle',
  type = 'primary',
  icon,
  ...props
}) => {
  const isLoading = loading || disabled;

  const handleClick = e => {
    if (!isLoading && onClick) {
      onClick(e);
    }
  };

  return (
    <button
      type={htmlType}
      onClick={handleClick}
      disabled={isLoading}
      className={`submit-button ${className}  btn-${type} btn-${size}`}
      style={style}
      {...props}
    >
      {isLoading && (
        <>
          <LoadingOutlined spin className="loading-icon" />
          <span className="button-text">{children}</span>
        </>
      )}
      {!isLoading && (
        <>
          {icon && <span className="button-icon">{icon}</span>}
          {children}
        </>
      )}
    </button>
  );
};

export default SubmitButton;

SubmitButton.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  htmlType: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  type: PropTypes.oneOf(['primary', 'default', 'dashed', 'text', 'link']),
  icon: PropTypes.node,
};
